import React from 'react';
import { Select, MenuItem, Checkbox, ListItemText, InputAdornment } from '@mui/material';
import { makeStyles } from '@mui/styles';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const useStyles = makeStyles({
  customSelect: {
    width: '100%',
    fontSize: 16,
    cursor: 'pointer',
    fontWeight: 500,
    color: '#000',
    borderRadius: '8px !important',
    outline: 'none',
    border: 'none',
    '&:focus': {
      border: 'none',
    },
    '& .MuiSelect-select': {
      width: '100% !important',
      borderRadius: '12px',
      fontSize: '16px',
    },
  },
  menuItem: {
    '&:hover': {
      backgroundColor: 'lightgray !important ',
    },
    // '&.Mui-selected': {
    //   backgroundColor: "lightgray !important"
    // }
  },
});


function CustomSelectField({
  onChange,
  value,
  selectOptions = [], // An array of options for the select dropdown
  border,
  readOnly,
  sx,
  isCategory,
}) {
  const classes = useStyles();

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  return (
    <>
      <Select
        // multiple
        displayEmpty
        className={classes.customSelect}
        sx={{
          ...(sx ? sx : {}),
          '& .MuiOutlinedInput-notchedOutline': {
            border: border ? '1px solid #0832DE !important' : 'none',
          },
        }}
        labelId="demo-multiple-checkbox-label"
        id="demo-multiple-checkbox"
        readOnly={!!readOnly}
        onChange={handleChange}
        value={value}
        IconComponent={KeyboardArrowDownIcon}
        renderValue={(selected) => <div style={{ color: '#365462' }}>{isCategory ? `Additional ${selected}` : selected}</div>}
      >
        {selectOptions.map((item) => (
          <MenuItem key={item} value={item} className={classes.menuItem}>
            <ListItemText primary={isCategory ? `Additional ${item}` : item} sx={{ paddingLeft: 1 }} />
          </MenuItem>
        ))}
      </Select >
    </>
  );
}

export default CustomSelectField;
